<div class="login-page">
  <div class="login-shell">
    <div class="login-brand">
      <h1 class="login-brand__title">{{ 'LOGIN.TITLE' | translate }}</h1>
      <p class="login-brand__subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>
    </div>

    <form *ngIf="!isLoggedIn && !tfaFlag && !resetQR && (loginType === 'both' || loginType === 'email')"
      [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="fb-card login-card">
      <div class="fb-card__header">{{ 'LOGIN.HEADER' | translate }}</div>
      <div class="fb-card__body">
        <div class="fb-col fb-col--12">
          <label class="fb-label" for="login-email">{{ 'LOGIN.EMAIL' | translate }}<span class="fb-req">*</span></label>
          <input id="login-email" type="email" autocomplete="email" required email class="fb-input"
            formControlName="email" [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
            [ngClass]="{'ng-invalid ng-touched': submitted && form.controls['email'].errors}" />
        </div>

        <div class="fb-col fb-col--12">
          <label class="fb-label" for="login-password">{{ 'LOGIN.PASSWORD' | translate }}<span
              class="fb-req">*</span></label>
          <input id="login-password" type="password" autocomplete="current-password" class="fb-input"
            formControlName="password" [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
            [ngClass]="{'ng-invalid ng-touched': submitted && form.controls['password'].errors}" />
        </div>

        <button type="submit" class="fb-btn fb-btn--primary login-btn" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
          <span>{{ 'LOGIN.SUBMIT' | translate }}</span>
        </button>

        <a routerLink="../forgot-password" class="login-link">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>

        <div class="login-divider" *ngIf="loginType === 'both'"><span>{{ 'LOGIN.OR' | translate }}</span></div>

        <button *ngIf="loginType === 'both'" type="button" class="fb-btn fb-btn--ghost login-btn"
          (click)="redireccion()">
          {{ 'LOGIN.CLAVE' | translate }}
        </button>
      </div>
    </form>

    <div *ngIf="!isLoggedIn && !tfaFlag && !resetQR && loginType === 'clave'" class="fb-card login-card">
      <div class="fb-card__header">{{ 'LOGIN.HEADER' | translate }}</div>
      <div class="fb-card__body">
        <button type="button" class="fb-btn fb-btn--primary login-btn" (click)="redireccion()">
          {{ 'LOGIN.CLAVE' | translate }}
        </button>
      </div>
    </div>

    <form *ngIf="tfaFlag" [formGroup]="form" (ngSubmit)="loginTfaEnabled()" novalidate class="fb-card login-card">
      <div class="fb-card__header">{{ 'LOGIN.TFA_HEADER' | translate }}</div>
      <div class="fb-card__body">
        <p class="login-intro">
          {{ 'LOGIN.TFA_INTRO' | translate }}
        </p>

        <div class="fb-col fb-col--12">
          <label class="fb-label" for="tfa-code">{{ 'LOGIN.TFA_CODE' | translate }}<span class="fb-req">*</span></label>
          <input id="tfa-code" type="text" autocomplete="one-time-code" class="fb-input login-otp"
            formControlName="totpkey" name="totpkey" placeholder="000000" maxlength="6"
            [ngClass]="{'ng-invalid ng-touched': submitted && form.controls['totpkey'].errors}" />
        </div>

        <button type="submit" class="fb-btn fb-btn--primary login-btn" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
          <span>{{ 'LOGIN.TFA_SUBMIT' | translate }}</span>
        </button>
      </div>
    </form>

    <div *ngIf="resetQR && !resetedQR" class="fb-card login-card" id="qr">
      <div class="fb-card__header">{{ 'LOGIN.QR_HEADER' | translate }}</div>
      <div class="fb-card__body">
        <p class="login-intro">
          {{ 'LOGIN.QR_INTRO' | translate }}
        </p>
        <p class="login-intro login-intro--mandatory" *ngIf="vpnActiva">
          {{ 'LOGIN.QR_MANDATORY' | translate }}
        </p>

        <div class="login-qr">
          <div *ngIf="loadingQr" class="profile-spinner">
            <span>{{ 'COMMON.LOADING' | translate }}</span>
          </div>
          <img *ngIf="!loadingQr && qr?.secretURL" [src]="qr.secretURL" alt="QR Authenticator" />
        </div>

        <form [formGroup]="form2" (ngSubmit)="guardarQR()" class="login-qr-form" *ngIf="qr?.secret">
          <div class="fb-col fb-col--12">
            <label class="fb-label" for="qr-code">{{ 'LOGIN.QR_CODE' | translate }}<span class="fb-req">*</span></label>
            <input id="qr-code" type="text" autocomplete="one-time-code" formControlName="totpkey" name="totpkey"
              class="fb-input login-otp" placeholder="000000" maxlength="6"
              [ngClass]="{'ng-invalid ng-touched': submitted && form2.controls['totpkey'].errors}" />
          </div>

          <button type="submit" class="fb-btn fb-btn--primary login-btn">{{ 'LOGIN.QR_SUBMIT' | translate }}</button>
          <button type="button" class="fb-btn fb-btn--ghost login-btn" (click)="cancelarEnrolamiento2FA()">
            {{ 'LOGIN.QR_CANCEL' | translate }}
          </button>
        </form>

        <div *ngIf="errorQR" class="login-alert">
          <p>{{ 'LOGIN.QR_ERROR' | translate }}</p>
        </div>
      </div>
    </div>

    <p *ngIf="resetedQR" class="login-done">
      {{ 'LOGIN.QR_DONE' | translate }}
    </p>
  </div>
</div>